"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputDatePopupRange = InputDatePopupRange;
exports.createRange = createRange;
exports.default = InputDateRange;
exports.fromParam = fromParam;
exports.textRange = textRange;
exports.toParam = toParam;
var React = _interopRequireWildcard(require("react"));
var _dateFns = require("date-fns");
var _Input = require("./Input");
var _utils = require("../utils");
var _Icon = _interopRequireDefault(require("../Icon"));
var _reactDatepicker = _interopRequireDefault(require("react-datepicker"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
// ----- UTIL

var thai = _utils.locale === 'th';
var d = (0, _dateFns.startOfToday)();
var w = (0, _dateFns.sub)(d, {
  weeks: 1
});
var m = (0, _dateFns.sub)(d, {
  months: 1
});
var y = (0, _dateFns.sub)(d, {
  years: 1
});
var RANGE_LISTs = [[thai ? 'วันนี้' : 'Today', d], [thai ? 'เมื่อวาน' : 'Yesterday', (0, _dateFns.sub)(d, {
  days: 1
})], [thai ? 'สัปดาห์นี้' : 'This Week', (0, _dateFns.startOfWeek)(d), (0, _dateFns.endOfWeek)(d)], [thai ? 'สัปดาห์ที่แล้ว' : 'Last Week', (0, _dateFns.startOfWeek)(w), (0, _dateFns.endOfWeek)(w)], [thai ? 'เดือนนี้' : 'This Month', (0, _dateFns.startOfMonth)(d), (0, _dateFns.endOfMonth)(d)], [thai ? 'เดือนที่แล้ว' : 'Last Month', (0, _dateFns.startOfMonth)(m), (0, _dateFns.endOfMonth)(m)], [thai ? 'ปีนี้' : 'This Year', (0, _dateFns.startOfYear)(d), (0, _dateFns.endOfYear)(d)], [thai ? 'ปีที่แล้ว' : 'Last Year', (0, _dateFns.startOfYear)(y), (0, _dateFns.endOfYear)(y)]];
function createRange() {
  var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'm';
  var d = new Date();
  if (mode === 'n') return [(0, _dateFns.startOfToday)(), null];
  if (mode === 'w') return [(0, _dateFns.startOfWeek)(d), (0, _dateFns.endOfWeek)(d)];
  if (mode === 'm') return [(0, _dateFns.startOfMonth)(d), (0, _dateFns.endOfMonth)(d)];
  if (mode === 'y') return [(0, _dateFns.startOfYear)(d), (0, _dateFns.endOfYear)(d)];
  return null;
}
function textRange(ds) {
  var dates = ds.filter(Boolean);
  if (dates.length === 2) {
    var d0x = (0, _utils.date)(dates[0]);
    var d1x = (0, _utils.date)(dates[1]);
    var d0 = d0x.split(' ');
    if ((0, _utils.sameDate)(dates[0], dates[1], 'd')) return (0, _utils.date)(dates[0]);
    if ((0, _utils.sameDate)(dates[0], dates[1], 'm')) return [d0[0], '-', d1x].filter(Boolean).join('');
    if ((0, _utils.sameDate)(dates[0], dates[1], 'y')) return [d0[0], d0[1], '-', d1x].filter(Boolean).join('');
    return [d0x, '-', d1x].filter(Boolean).join(' ');
  }
  if (dates.length === 1) return (0, _utils.date)(dates[0]);
  return '';
}
function toParam(dates, mode) {
  if (!dates) return null;
  if (mode === 'o') {
    if (Array.isArray(dates)) {
      var _start = (0, _utils.date)(dates[0], 'P');
      if (_start) {
        var end = dates.length === 2 ? (0, _utils.date)(dates[1], 'P') : null;
        return _start + (end ? ' - ' + end : '');
      }
    }
    return (0, _utils.date)(dates[0], 'P');
  }
  if (Array.isArray(dates)) {
    var _start2 = (0, _utils.dbdate)(dates[0]);
    if (_start2) {
      var _end = dates.length === 2 ? (0, _utils.dbdate)(dates[1]) : null;
      return encodeURI(_start2 + (_end ? '_' + _end : ''));
    }
  }
  var start = (0, _utils.dbdate)(dates[0]);
  return start && encodeURI(start);
}
function fromParam(date) {
  if (date) {
    var _d = date.split('_');
    if (_d.length === 2) return [(0, _utils.todate)(_d[0]), (0, _utils.todate)(_d[1])];
    return [(0, _utils.todate)(_d[0]), null];
  }
  return '';
}

// ----- COMPONENT

function InputDateRange(props) {
  var value = props.value,
    _onChange = props.onChange,
    valueFormat = props.valueFormat,
    icon = props.icon,
    label = props.label,
    fixWidth = props.fixWidth,
    classBox = props.classBox;
  var onClear = function onClear() {
    return _onChange(null);
  };
  var onChangeText = function onChangeText(e) {
    // TODO คิดมุขก่อนว่า จะแก้ยังไงได้
  };
  var isValue = function isValue() {
    return Array.isArray(value) && (0, _dateFns.isValid)(value[0]);
  };
  var getText = function getText() {
    var text = '';
    if (Array.isArray(value) && (0, _dateFns.isValid)(value[0])) {
      text = (0, _utils.date)(value[0], valueFormat || 'S');
      if (value.length > 1 && value[1] && (0, _dateFns.isValid)(value[1]) && !(0, _dateFns.isSameDay)(value[0], value[1])) text += ' - ' + (0, _utils.date)(value[1], valueFormat || 'S');
    }
    return text;
  };
  var inputProp = {
    value: value || '',
    onChange: function onChange(date) {
      return _onChange(date);
    },
    popupOffset: [icon ? -35 : -7, 10]
  };
  var input = /*#__PURE__*/React.createElement("div", {
    className: (0, _utils.clsNames)((0, _Input.createInputboxClass)('un-input-date -range', props), isValue() && '-focus', fixWidth && '-fix-width')
  }, !!icon && /*#__PURE__*/React.createElement("div", {
    className: "un-inputbox-pend"
  }, (0, _Input.testIcon)(icon, 'calendar-day')), /*#__PURE__*/React.createElement("div", {
    className: "un-inputbox-control"
  }, /*#__PURE__*/React.createElement(InputDatePopupRange, inputProp, function (value, onClick, ref) {
    if (props.botton) return /*#__PURE__*/React.createElement("div", {
      className: "un-inputbox-text",
      onClick: onClick
    }, getText());
    return /*#__PURE__*/React.createElement("input", {
      key: 'i' + (0, _utils.dbdate)(value),
      type: 'text',
      className: "un-inputbox-input",
      ref: ref,
      onClick: onClick,
      defaultValue: getText(),
      onChange: onChangeText
    });
  }), !props.form && !!label && (0, _Input.createInputboxLabel)(label)), !props.noClear && isValue() && /*#__PURE__*/React.createElement("div", {
    className: "un-inputbox-pend"
  }, /*#__PURE__*/React.createElement(_Icon.default, {
    name: 'times',
    className: 'un-inputbox-clear',
    onClick: onClear
  })));
  if (props.form) return (0, _Input.createFormitem)(input, props);
  if (typeof classBox === 'string') return /*#__PURE__*/React.createElement("div", {
    className: classBox
  }, input);
  return input;
}
function InputDatePopupRange(props) {
  var _useState = (0, React.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    from = _useState2[0],
    setFrom = _useState2[1];
  var _useState3 = (0, React.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    to = _useState4[0],
    setTo = _useState4[1];
  var onChange = function onChange(from, to) {
    if (props.onChange) props.onChange(from ? [from, to] : null);
  };
  var resetDay = function resetDay() {
    setFrom(null);
    setTo(null);
    return true;
  };
  var setChange = function setChange(item) {
    var _to = item.length > 2 ? item[2] : item[1];
    setFrom(item[1]);
    setTo(_to);
    //onChange(item[1], _to)
  };

  var isActiveDate = function isActiveDate(items, from, to) {
    if (items.length > 2) return (0, _utils.sameDate)(items[1], from, 'd') && (0, _utils.sameDate)(items[2], to, 'd');
    if (items.length > 1) return (0, _utils.sameDate)(items[1], from, 'd') && ((0, _utils.isEmpty)(to) || (0, _utils.sameDate)(items[1], to, 'd'));
    return false;
  };

  // USE EFFECT

  (0, React.useEffect)(function () {
    if (Array.isArray(props.value) && props.value.length === 2) {
      var _from = (0, _utils.todate)(props.value[0]);
      var _to2 = (0, _utils.todate)(props.value[1]);
      setFrom(_from || null);
      setTo(_to2 || null);
    } else {
      resetDay();
    }
  }, [props.value]);

  // ----- RENDER

  var InputNative = /*#__PURE__*/(0, React.forwardRef)(function (e, ref) {
    return props.children(e.value, e.onClick, ref);
  });
  var popperModifiers = [];
  if (props.popupOffset) popperModifiers.push({
    name: 'offset',
    options: {
      offset: props.popupOffset
    }
  });
  var inputProp = {
    locale: _utils.locale,
    portalId: 'root-portal',
    customInput: /*#__PURE__*/React.createElement(InputNative, null),
    dateFormat: 'yyyy-MM-dd',
    startDate: from,
    endDate: to,
    onChange: function onChange(dates) {
      setFrom(dates[0]);
      setTo(dates[1]);
    },
    onCalendarClose: function onCalendarClose() {
      return onChange(from, to);
    },
    closeOnScroll: true,
    selectsRange: true,
    monthsShown: 2,
    popperClassName: 'un-popup-date',
    popperModifiers: popperModifiers,
    calendarContainer: function calendarContainer(c) {
      return /*#__PURE__*/React.createElement("div", {
        className: c.className
      }, c.showPopperArrow && /*#__PURE__*/React.createElement("div", _extends({
        className: "react-datepicker__triangle"
      }, c.arrowProps)), /*#__PURE__*/React.createElement("div", {
        className: "un-popup-date-range"
      }, RANGE_LISTs.map(function (o, x) {
        return /*#__PURE__*/React.createElement("div", {
          key: x,
          className: (0, _utils.clsNames)('btn', 'fix-popup', isActiveDate(o, from, to) && '-active'),
          onClick: function onClick() {
            return setChange(o);
          }
        }, o[0]);
      })), c.children);
    },
    renderCustomHeader: function renderCustomHeader(c) {
      return /*#__PURE__*/React.createElement("div", {
        className: 'un-popup-date-header'
      }, c.prevMonthButtonDisabled || c.customHeaderCount !== 0 ? /*#__PURE__*/React.createElement("div", {
        className: 'mr-auto'
      }) : /*#__PURE__*/React.createElement(_Icon.default, {
        button: true,
        onClick: c.decreaseMonth,
        name: 'chevron-left mr-auto',
        className: 'fix-popup'
      }), /*#__PURE__*/React.createElement("div", {
        className: '_name'
      }, (0, _utils.date)(c.monthDate, 'Z')), c.nextMonthButtonDisabled || c.customHeaderCount !== 1 ? /*#__PURE__*/React.createElement("div", {
        className: 'ml-auto'
      }) : /*#__PURE__*/React.createElement(_Icon.default, {
        button: true,
        onClick: c.increaseMonth,
        name: 'chevron-right ml-auto',
        className: 'fix-popup'
      }));
    }
  };
  return /*#__PURE__*/React.createElement(_reactDatepicker.default, inputProp);
}